// hooks/useProductForm.js
import { useState, useEffect } from "react";
import { productService } from "../../services/productService.js";
import { toast } from "sonner";

export const useProductForm = (editingProduct = null) => {
  const [loading, setLoading] = useState(false);
  const [productData, setProductData] = useState({
    name: "",
    image: null,
    category: "",
    description: "",
    price: "",
  });

  useEffect(() => {
    if (editingProduct) {
      setProductData({
        name: editingProduct.name || "",
        image: editingProduct.image || null,
        category: editingProduct.category?.toLowerCase() || "",
        description: editingProduct.description || "",
        price: editingProduct.price?.toString() || "",
      });
    }
  }, [editingProduct]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const formData = new FormData();
      Object.keys(productData).forEach((key) => {
        if (productData[key] !== null) {
          formData.append(key, productData[key]);
        }
      });

      const response = editingProduct
        ? await productService.updateProduct(editingProduct.id, formData)
        : await productService.addProduct(formData);

      if (response.success) {
        toast.success(response.message || "Producto guardado exitosamente");
        return true;
      } else {
        toast.error(response.message || "Error al guardar el producto");
        return false;
      }
    } catch (error) {
      toast.error(error.message || "Error al procesar la solicitud");
      return false;
    } finally {
      setLoading(false);
    }
  };

  return {
    productData,
    setProductData,
    loading,
    handleSubmit,
  };
};
